import React from 'react';
import { Usp, UspProps } from '../components';
import { DivProps } from '@kizi/core-components';

export const CbMembership: React.FC<UspProps & DivProps> = ({
  title,
  items = [],
  icon,
  iconSize,
  variant,
  bottomText,
  ...props
}) => {
  return (
    <Usp
      variant={variant}
      title={title}
      items={items}
      icon={icon}
      iconSize={iconSize}
      bottomText={bottomText}
      my={3}
      {...props}
    />
  );
};
